import { MENU, ONB_POST_REGISTRATION, REGISTRATION } from '@/routing/routes';

export function isRegistrationRoute(route) {
    return route === REGISTRATION || route === ONB_POST_REGISTRATION;
}

export function isMenuRoute(route) {
    return route === MENU;
}
